export const EMPTY_TIME_SLOT = Object.freeze({
  start_time: "",
  end_time: "",
} as const);
